
<template>
<v-app>
  <cabecera/>
    <v-main style="background-color:#6D9886;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container>
    <section id="main-cabecera" class="mb-4">
     <v-card  color="#393E46">
       <v-card-title><h1 class="display-2 font-weight-bold mb-3">
         {{ $t("politicas.titulo")}}
       </h1></v-card-title>
       <v-card-text>
       <v-row align="center" class="text-center">

    <v-col cols="12" sm="12" md="12" lg="12">
    <h3 class="">
      {{ $t("politicas.informaciontit")}}
    </h3>
      <p class="text-lg-justify text-justify">
        {{ $t("politicas.informacionpar")}}
      </p>
          </v-col>
         <v-col cols="12" sm="12" md="12" lg="12">
           <h3 class="">
             {{ $t("politicas.objetivotit")}}
           </h3>
           <p class="text-lg-justify text-justify">
             {{ $t("politicas.objetivopar")}}
           </p>
         </v-col>
         <v-col cols="12" sm="12" md="12" lg="12">
           <h3 class="">
             {{ $t("politicas.principiosrecttit")}}
           </h3>
           <p class="text-lg-justify text-justify">
             {{ $t("politicas.principiosrectpar")}}
           </p>
         </v-col>
         <v-col cols="12" sm="12" md="12" lg="12">
           <h3 class="">
             {{ $t("politicas.alcancetit")}}
           </h3>
           <p class="text-lg-justify text-justify">
             {{ $t("politicas.alcancepar")}}
           </p>
         </v-col>
         <v-col cols="12" sm="12" md="12" lg="12">
           <h3 class="">
             {{ $t("politicas.finalidadtit")}}
           </h3>
           <p class="text-lg-justify text-justify">
             {{ $t("politicas.finalidadpar")}}
           </p>
         </v-col>
         <v-col cols="12" sm="12" md="12" lg="12">
           <h3 class="">
             {{ $t("politicas.transftit")}}
           </h3>
           <p class="text-lg-justify text-justify">
             {{ $t("politicas.transfpar")}}
           </p>
         </v-col>
         <v-col cols="12" sm="12" md="12" lg="12">
           <h3 class="">
             {{ $t("politicas.autotit")}}
           </h3>
           <p class="text-lg-justify text-justify">
             {{ $t("politicas.autopar")}}
           </p>
         </v-col>
         <v-col cols="12" sm="12" md="12" lg="12">
           <h3 class="">
             {{ $t("politicas.derectit")}}
           </h3>
           <p class="text-lg-justify text-justify">
             {{ $t("politicas.derecpar")}}
           </p>
         </v-col>
         <v-col cols="12" sm="12" md="12" lg="12">
           <h3 class="">
             {{ $t("politicas.procedtit")}}
           </h3>
           <p class="text-lg-justify text-justify">
             {{ $t("politicas.procedpar")}}
           </p>
         </v-col>
         <v-col cols="12" sm="12" md="12" lg="12">
           <h3 class="">
             {{ $t("politicas.consentit")}}
           </h3>
           <p class="text-lg-justify text-justify">
             {{ $t("politicas.consenpar")}}
           </p>
         </v-col>
         <v-col cols="12" sm="12" md="12" lg="12">
           <h3 class="">
             {{ $t("politicas.vigenciatit")}}
           </h3>
           <p class="text-lg-justify text-justify">
             {{ $t("politicas.vigenciapar")}}
           </p>
         </v-col>
         <v-col cols="12" sm="12" md="12" lg="12">
           <h3 class="">
             {{ $t("politicas.modifictit")}}
           </h3>
           <p class="text-lg-justify text-justify">
             {{ $t("politicas.modificpar")}}
           </p>
         </v-col>
       </v-row>
       </v-card-text> </v-card> </section>


  </v-container>
    </v-main>
    <piepagina/>
  </v-app>
</template>

<script>

import cabecera from '../general/cabecera';
import piepagina from '../general/piepagina';
import Cabecerabaja from "@/components/general/cabecerabaja";
  export default {
    name: 'politicas',
    components: {
      Cabecerabaja,
    cabecera,
    piepagina,
  },
    data () {
      return {
        clientesimg: [],
        email: '',
        emailRules: [
          v => !!v || 'Se necesita el Email',
          v => /.+@.+/.test(v) || 'E-mail debe ser valido',
        ]
          }
    },

  }
</script>
